// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const ConfirmationDialogItem = styled.div`
  margin-top: 15px;
  
  >button {
    min-height: 40px;
    min-width: 100px;
    padding: 12px 24px;
    font-size: 14px;
    margin-right: 15px;
  }
`;

export const ConfirmationDescription = styled.div`
  > span {
    display: block;
    margin-bottom: 5px;
  }
`;